import React, { Component } from 'react';
import Slider from 'react-slick';
import moment from 'moment/moment';

export default class Events extends Component {
  render() {
    return (
      <section className={`d-none d-sm-block ${this.props.background}`} id="events">
        <div className="container mt-5 mb-5 txt-white">
          <div className="row">
            <div className="col-12 mb-4">
              <span className="txt-bold txt-25px txt-white txt-uppercase">Events</span>
            </div>
            <div className="col-12">
              {this.props.data.length > 0 ? (
                <Slider
                  {...{
                    centerPadding: '60px',
                    slidesToShow: this.props.data.length >= 3 ? 3 : this.props.data.length,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 6000,
                  }}
                >
                  {this.props.data.map((item, index) => (
                    <div key={index} className="gas-slide">
                      <img src={item.image} alt={item.name} />
                      <div className="text-center mt-2">
                        <div className="txt-title txt-white text-uppercase" style={{ fontSize: 22 }}>
                          {item.name}
                        </div>
                        {this.props.showPlace && <div className="txt-regular">@{item.groupe.name}</div>}
                        <div className="txt-thin">
                          {moment(item.date).format('DD/MM/YYYY HH:mm')}
                          <span
                            className="fa fa-info-circle"
                            style={{ marginLeft: 5 }}
                            onClick={() => alert(item.description)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              ) : (
                <div className="pt-5 pb-5">
                  <span className="fas fa-circle-o-notch fa-5x fa-spin" />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Events.js